import type { ContractType } from "@/pages/human-resources/time-management/business/contract/ContractType.ts";

export class Contract {
  constructor(
    public readonly id: string,
    public readonly siteId: string,
    public readonly contractType: ContractType,
    public readonly originalStart: Date,
    public readonly start: Date,
    public readonly end: Date | undefined,
    public readonly roleId: string,
    public readonly sectionId: string,
    public readonly weeklyWorkingHours: number | undefined,
    public readonly monthlyWorkingHours: number | undefined,
  ) {}

  public isEffectiveAtDate(date: Date): boolean {
    return (
      this.start.getTime() <= date.getTime() &&
      (this.end === undefined || this.end.getTime() >= date.getTime())
    );
  }

  public computeMonthlyHours(): number | undefined {
    if (this.monthlyWorkingHours !== undefined) {
      return this.monthlyWorkingHours;
    }
    if (this.weeklyWorkingHours !== undefined) {
      return (this.weeklyWorkingHours * 13) / 3;
    }
    return undefined;
  }

  public computeMonthlyMinutes(): number | undefined {
    const hours = this.computeMonthlyHours();
    return hours !== undefined ? hours * 60 : undefined;
  }
}
